import { useQuery } from '@apollo/client/react'
import { Box, Button, Center, Separator, Spinner, VStack } from '@chakra-ui/react'
import { UserSearchForm } from '@src/components/sco/Matching/UserSearchForm'
import { UserSearchesList } from '@src/components/sco/Matching/UserSearchesList'
import { USER_SEARCH_FRAGMENT } from '@src/components/sco/Matching/userSearchFragment'
import { membersNavSections } from '@src/components/sco/Members/MembersLayout/MembersNav'
import { SidebarCollapsingNavList } from '@src/components/sco/SidebarCollpasingNavList'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import { gql } from '@src/lib/gql'
import React, { ReactNode } from 'react'

export const MatchingNav = (props: { children?: ReactNode; userSearchId?: string }) => {
  const { currentUser } = useCurrentUser()
  const query = useQuery(
    gql`
      query ($userSearchId: String) {
        scoUserSearch(userSearchId: $userSearchId) {
          id
          userSearchId
          ${USER_SEARCH_FRAGMENT}
        }
      }
    `,
    {
      skip: !props.userSearchId,
      variables: {
        userSearchId: props.userSearchId,
      },
    }
  )

  return (
    <VStack align={'stretch'} gap={0} height={'full'} justify={'stretch'} width={'full'}>
      <SidebarCollapsingNavList
        collapsed={true}
        defaultTitle={'Member Matching'}
        items={membersNavSections}
      />
      {currentUser?.isRegistered && (
        <>
          {props.userSearchId ? (
            <>
              {query.data?.scoUserSearch ? (
                <>
                  <UserSearchForm userSearch={query.data.scoUserSearch} />
                  <Separator />
                  <Box paddingY={'1em'}>
                    <Button asChild size={'sm'} variant={'outline'} width={'full'}>
                      <NextLink href={'/members/matching'}>New Search</NextLink>
                    </Button>
                  </Box>
                </>
              ) : (
                <Center paddingY={'1em'}>
                  <Spinner />
                </Center>
              )}
            </>
          ) : (
            <Box overflowY={'auto'} paddingY={3}>
              <UserSearchesList excludeEmptyResults={true} />
            </Box>
          )}
        </>
      )}
    </VStack>
  )
}
